(function() { window.GUID_f5ef0512_8982_4e1d_8aa2_05ee06359e65 = { getGuid: function() { return "f5ef0512-8982-4e1d-8aa2-05ee06359e65"; } }; })();
var Kiosk;
(function (Kiosk) {
    $(function () {
        $('#UserEmail').on('keydown', function (e) {
            if (e.which == 13) {
                $('#btnSetUser').trigger('click');
            }
        });
        $('#btnSetUser').on('click', function () {
            window.location = CSParameters.BaseUrl + "Portal/Kiosk?UserEmail=" + $('#UserEmail').val();
        });
        $('body').on('contextmenu', function (e) {
            e.preventDefault();
            return false;
        });
        $(".PortalItemLink").on('click', function (e) {
            e.preventDefault(); //this will prevent the link trying to navigate to another page
            var href = $(this).attr("href"); //get the href so we can navigate later
            //alert(href);
            //when update has finished, navigate to the other page
            window.location.replace(href);
        });
    });
})(Kiosk || (Kiosk = {}));

//# sourceMappingURL=Kiosk.js.map
